import Badge from "areas/product/jewlr/wizard-header/badge"
import Media from "components/ui/media"
import Shimmer from "components/ui/shimmer"
import { IS_JEWLR } from "helpers/application"
import { cn } from "styles/utils"

import WizardPricingLoading from "./wizard-pricing-loading"

const WizardHeaderLoading = () => {
  return (
    <>
      {IS_JEWLR() && (
        <Media greaterThanOrEqual="tablet">
          <Badge />
        </Media>
      )}
      <Shimmer
        className="tablet:h-(--tablet-height) tablet-w-(--tablet-width) h-(--base-height) mb-8 w-full rounded-sm"
        style={{
          "--base-height": "42px",
          "--tablet-height": "28px",
          "--tablet-width": "320px",
        }}
      />
      <WizardPricingLoading />
      {IS_JEWLR() && (
        <Shimmer
          className={cn(
            "h-(--base-height) w-full rounded-sm",
            sl.config.klarna_osm_pdp && "tablet:h-(--tablet-height)"
          )}
          style={{
            "--base-height": sl.config.klarna_osm_pdp ? "38px" : "18px",
            "--tablet-height": "21px",
          }}
        />
      )}
    </>
  )
}

export default WizardHeaderLoading
